"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrders = void 0;
var react_1 = require("react");
var orders_interface_1 = require("../interfaces/orders.interface");
var useOrders = function (orderType) {
    var _a = (0, react_1.useState)([]), orders = _a[0], setOrders = _a[1];
    var _b = (0, react_1.useState)([]), statuses = _b[0], setStatuses = _b[1];
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var getEndpoint = function () {
        switch (orderType) {
            case orders_interface_1.OrderType.CREDIT:
                return 'orders_credits';
            case orders_interface_1.OrderType.BUYOUT:
                return 'orders_buyouts';
            case orders_interface_1.OrderType.EXCHANGE:
                return 'orders_exchanges';
            case orders_interface_1.OrderType.INSTALLMENT:
                return 'orders_installments';
            case orders_interface_1.OrderType.CALL_REQUEST:
                return 'orders_call_requests';
            case orders_interface_1.OrderType.CATALOG_ORDER:
                return 'car_catalog_orders';
            default:
                return '';
        }
    };
    var fetchOrders = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var endpoint, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    endpoint = getEndpoint();
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/").concat(endpoint))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    setOrders(data);
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error fetching orders:', error_1);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [orderType]);
    var fetchStatuses = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/order_statuses"))];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    setStatuses(data);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error fetching statuses:', error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    (0, react_1.useEffect)(function () {
        fetchOrders();
        fetchStatuses();
    }, [fetchOrders, fetchStatuses]);
    var updateOrderStatus = function (orderId, newStatusId) { return __awaiter(void 0, void 0, void 0, function () {
        var endpoint, response, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    endpoint = getEndpoint();
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/").concat(endpoint, "/").concat(orderId), {
                            method: 'PATCH',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify((_a = {},
                                _a[orderType === orders_interface_1.OrderType.CATALOG_ORDER ? "car_".concat(orderType) : "orders_".concat(orderType)] = {
                                    order_status_id: newStatusId,
                                },
                                _a)),
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.ok];
                case 2:
                    error_3 = _b.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deleteOrder = function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
        var endpoint, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = getEndpoint();
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/").concat(endpoint, "/").concat(orderId), {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.ok];
            }
        });
    }); };
    return {
        orders: orders,
        statuses: statuses,
        loading: loading,
        refreshOrders: fetchOrders,
        updateOrderStatus: updateOrderStatus,
        deleteOrder: deleteOrder,
    };
};
exports.useOrders = useOrders;
